import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "././components/Home/Home.jsx";
import Language from "././components/Language/Language.jsx";
import Units from "././components/EngUnits/Units.jsx";
import UrduUnits from "././components/UrduUnits/UrduUnits.jsx";
// local government
import PashtoUnits from "././components/PashtoUnits/PashtoUnits.jsx";
import LGEnglish from "././components/LGEng/LGEng.jsx";
import LGUrdu from "././components/LGUrdu/LGUrdu.jsx";
import LGPashto from "././components/LGPashto/LGPashto.jsx";
import LGEnglishDetails from "././components/LGEng/LGEnglishDetails.jsx";
import LGUrduDetails from "././components/LGUrdu/LGUrduDetails.jsx";
import LGPashtoDetails from "././components/LGPashto/LGPashtoDetails.jsx";
import data from "./Data/Data.js";
// covid
import CovidEngTopicsDetails from "././components/Covid/CovidEng/CovidEngTopicsDetails.jsx";
import CovidEngTopics from "././components/Covid/CovidEng/CovidEngTopics.jsx";
import CovidUrduDetails from "././components/Covid/CovidUrdu/CovidUrduDetails.jsx";
import CovidUrduTopics from "././components/Covid/CovidUrdu/CovidUrduTopics.jsx";
import CovidPashtoDetails from "././components/Covid/CovidPashto/CovidPashtoDetails.jsx";
import CovidPashtoTopics from "././components/Covid/CovidPashto/CovidPashtoTopics.jsx";
import CovidData from "././components/Covid/Data/Data";
//General
import GeneralEngTopicsDetails from "././components/General/GeneralEng/GeneralEngTopicsDetails.jsx";
import GeneralEngTopics from "././components/General/GeneralEng/GeneralEngTopics.jsx";
import GeneralUrduDetails from "././components/General/GeneralUrdu/GeneralUrduDetails.jsx";
import GeneralUrduTopics from "././components/General/GeneralUrdu/GeneralUrduTopics.jsx";
import GeneralPashtoDetails from "././components/General/GeneralPashto/GeneralPashtoDetails.jsx";
import GeneralPashtoTopics from "././components/General/GeneralPashto/GeneralPashtoTopics.jsx";
import GeneralData from "././components/General/Data.js";

import FeedBackForm from "././components/FeedBackForm/FeedBackForm.jsx";
import Notfound from "././components/NotFound/Notfound.jsx";

function App() {
  const searchTag = <span style={{ color: "#35096d" }}>Search For Topics</span>;
  const searchTagUrdu = (
    <span style={{ color: "#35096d", fontSize: "20px" }}>
      عنوانات تلاش کریں
    </span>
  );
  const searchTagPashto = (
    <span style={{ color: "#35096d", fontSize: "20px" }}>د موضوعاتو لټون</span>
  );

  // LG search

  const [searchTerm, setSearchTerm] = React.useState("");
  const [searchResults, setSearchResults] = React.useState([]);
  const [UrduSearch, setUrduSearch] = React.useState([]);
  const [PashtoSearch, setPashtoSearch] = React.useState([]);
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };
  React.useEffect(() => {
    const Engresults = data.filter((dataObj) =>
      dataObj.title.toLowerCase().includes(searchTerm)
    );
    setSearchResults(Engresults);

    const Urduresults = data.filter((dataObj) =>
      dataObj.Utitle.toLowerCase().includes(searchTerm)
    );
    setUrduSearch(Urduresults);
    const pashtoresults = data.filter((dataObj) =>
      dataObj.Ptitle.toLowerCase().includes(searchTerm)
    );
    setPashtoSearch(pashtoresults);
  }, [searchTerm]);

  // //////////// General

  const [GeneralsearchTerm, setGeneralSearchTerm] = React.useState("");
  const [GeneralsearchResults, setGeneralSearchResults] = React.useState([]);
  const [GeneralUrduSearch, setGeneralUrduSearch] = React.useState([]);
  const [GeneralPashtoSearch, setGeneralPashtoSearch] = React.useState([]);
  const handleGeneralChange = (e) => {
    setGeneralSearchTerm(e.target.value);
  };
  React.useEffect(() => {
    const Engresults = GeneralData.filter((dataObj) =>
      dataObj.title.toLowerCase().includes(GeneralsearchTerm)
    );
    setGeneralSearchResults(Engresults);

    const Urduresults = GeneralData.filter((dataObj) =>
      dataObj.Utitle.toLowerCase().includes(GeneralsearchTerm)
    );
    setGeneralUrduSearch(Urduresults);
    const pashtoresults = GeneralData.filter((dataObj) =>
      dataObj.Ptitle.toLowerCase().includes(GeneralsearchTerm)
    );
    setGeneralPashtoSearch(pashtoresults);
  }, [GeneralsearchTerm]);

  // ///////////////////////////// Covid

  const [CovidsearchTerm, setCovidSearchTerm] = React.useState("");
  const [CovidsearchResults, setCovidSearchResults] = React.useState([]);
  const [CovidUrduSearch, setCovidUrduSearch] = React.useState([]);
  const [CovidPashtoSearch, setCovidPashtoSearch] = React.useState([]);
  const handleCovidChange = (e) => {
    setCovidSearchTerm(e.target.value);
  };
  React.useEffect(() => {
    const Engresults = CovidData.filter((dataObj) =>
      dataObj.title.toLowerCase().includes(CovidsearchTerm)
    );
    setCovidSearchResults(Engresults);

    const Urduresults = CovidData.filter((dataObj) =>
      dataObj.Utitle.toLowerCase().includes(CovidsearchTerm)
    );
    setCovidUrduSearch(Urduresults);
    const pashtoresults = CovidData.filter((dataObj) =>
      dataObj.Ptitle.toLowerCase().includes(CovidsearchTerm)
    );
    setCovidPashtoSearch(pashtoresults);
  }, [CovidsearchTerm]);

  return (
    <>
      <Switch>
        <Route exact path="/FeedBackForm">
          <FeedBackForm />
        </Route>
        {/* local government */}
        <Route exact path="/LGEnglishDetails/:Id">
          <LGEnglishDetails />
        </Route>
        <Route exact path="/LGUrduDetails/:Id">
          <LGUrduDetails />
        </Route>
        <Route exact path="/LGPashtoDetails/:Id">
          <LGPashtoDetails />
        </Route>

        <Route exact path="/LGEnglish">
          <LGEnglish
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            handleChange={handleChange}
            searchTag={searchTag}
          />
        </Route>
        <Route exact path="/LGUrdu">
          <LGUrdu
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            UrduSearch={UrduSearch}
            setUrduSearch={setUrduSearch}
            handleChange={handleChange}
            searchTagUrdu={searchTagUrdu}
          />
        </Route>
        <Route exact path="/LGPashto">
          <LGPashto
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            PashtoSearch={PashtoSearch}
            setPashtoSearch={setPashtoSearch}
            handleChange={handleChange}
            searchTagPashto={searchTagPashto}
          />
        </Route>
        {/* ////////// */}
        {/* Covid */}

        <Route exact path="/CovidEngTopicsDetails/:Id">
          <CovidEngTopicsDetails />
        </Route>
        <Route exact path="/CovidUrduDetails/:Id">
          <CovidUrduDetails />
        </Route>
        <Route exact path="/CovidPashtoDetails/:Id">
          <CovidPashtoDetails />
        </Route>
        <Route exact path="/CovidEngTopics">
          <CovidEngTopics
            CovidsearchTerm={CovidsearchTerm}
            setCovidSearchTerm={setCovidSearchTerm}
            CovidsearchResults={CovidsearchResults}
            setCovidSearchResults={setCovidSearchResults}
            handleCovidChange={handleCovidChange}
            searchTag={searchTag}
          />
        </Route>
        <Route exact path="/CovidUrduTopics">
          <CovidUrduTopics
            CovidsearchTerm={CovidsearchTerm}
            setCovidSearchTerm={setCovidSearchTerm}
            CovidsearchResults={CovidsearchResults}
            setCovidSearchResults={setCovidSearchResults}
            CovidUrduSearch={CovidUrduSearch}
            setCovidUrduSearch={setCovidUrduSearch}
            handleCovidChange={handleCovidChange}
            searchTagUrdu={searchTagUrdu}
          />
        </Route>
        <Route exact path="/CovidPashtoTopics">
          <CovidPashtoTopics
            CovidsearchTerm={CovidsearchTerm}
            setCovidSearchTerm={setCovidSearchTerm}
            CovidsearchResults={CovidsearchResults}
            setCovidSearchResults={setCovidSearchResults}
            CovidUrduSearch={CovidUrduSearch}
            setCovidUrduSearch={setCovidUrduSearch}
            CovidPashtoSearch={CovidPashtoSearch}
            setCovidPashtoSearch={setCovidPashtoSearch}
            handleCovidChange={handleCovidChange}
            searchTagPashto={searchTagPashto}
          />
        </Route>
        {/* //////////////////////////////////////////////// */}
        {/* General */}
        <Route exact path="/GeneralEngTopicsDetails/:Id">
          <GeneralEngTopicsDetails />
        </Route>
        <Route exact path="/GeneralUrduDetails/:Id">
          <GeneralUrduDetails />
        </Route>
        <Route exact path="/GeneralPashtoDetails/:Id">
          <GeneralPashtoDetails />
        </Route>
        <Route exact path="/GeneralEngTopics">
          <GeneralEngTopics
            GeneralsearchTerm={GeneralsearchTerm}
            setGeneralSearchTerm={setGeneralSearchTerm}
            GeneralsearchResults={GeneralsearchResults}
            GeneralUrduSearch={GeneralUrduSearch}
            GeneralPashtoSearch={GeneralPashtoSearch}
            handleGeneralChange={handleGeneralChange}
            searchTag={searchTag}
          />
        </Route>
        <Route exact path="/GeneralUrduTopics">
          <GeneralUrduTopics
            GeneralsearchTerm={GeneralsearchTerm}
            setGeneralSearchTerm={setGeneralSearchTerm}
            GeneralsearchResults={GeneralsearchResults}
            GeneralUrduSearch={GeneralUrduSearch}
            GeneralPashtoSearch={GeneralPashtoSearch}
            handleGeneralChange={handleGeneralChange}
            searchTagUrdu={searchTagUrdu}
          />
        </Route>
        <Route exact path="/GeneralPashtoTopics">
          <GeneralPashtoTopics
            GeneralsearchTerm={GeneralsearchTerm}
            setGeneralSearchTerm={setGeneralSearchTerm}
            GeneralsearchResults={GeneralsearchResults}
            GeneralUrduSearch={GeneralUrduSearch}
            GeneralPashtoSearch={GeneralPashtoSearch}
            handleGeneralChange={handleGeneralChange}
            searchTagPashto={searchTagPashto}
          />
        </Route>
        <Route exact path="/EngUnits">
          <Units />
        </Route>
        <Route exact path="/UrduUnits">
          <UrduUnits />
        </Route>
        <Route exact path="/PashtoUnits">
          <PashtoUnits />
        </Route>
        <Route exact path="/language">
          <Language />
        </Route>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/not-found" component={Notfound} />
        <Route path="/not-found" component={Notfound} />
        <Redirect to="/not-found" />
      </Switch>
    </>
  );
}

export default App;
